import React from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { t } from 'i18next';
import CheckBoxSingleBool from '@lib/components/CheckBoxSingleBool/CheckBoxSingleBool';
import CheckBoxAsToggle from '@lib/components/CheckBoxAsToggle/CheckBoxAsToggle';
import { LOCALES_DEBUG } from '@lib/enums/localStorageKeys';

export default function LocalesDebugField() {
  const [isDebug, setDebug] = useLocalStorage(LOCALES_DEBUG, false);
  const onChange = (v: boolean) => {
    setDebug(v);
    window.location.reload();
  };
  return (
    <div style={{ display: 'flex' }}>
      <CheckBoxSingleBool
        name="locales-debug"
        value={isDebug}
        options={[{ label: 'checked', value: 'checked' }]}
        onChange={onChange}
        label={t('locales-debug')}
        CheckBoxComponent={CheckBoxAsToggle}
        labelTypographyProps={{ variant: 'caption', strong: false }}
      />
    </div>
  );
}
